// extracted by mini-css-extract-plugin
export default {"iconbutton__wrapper":"iconButton_iconbutton__wrapper__HQvAE","button":"iconButton_button__iJ-Ni","button__text":"iconButton_button__text__p2XRx"};